import {
 useMutation
}
from
'@tanstack/react-query';

import toast
from
'react-hot-toast';

import {
 serviceServices
}
from
'../services/service.service';



export const
useUploadServiceVideo=
()=>{


 return useMutation({

   mutationFn:
   async(file)=>{

      return await

      serviceServices

      .uploadVideo(

         file

      );

   },



   onError:()=>{

      toast.error(

        'Video upload failed'

      );

   }

 });


};